export default __webpack_public_path__ + "/assets/eventi-01.png";